import React, { useState } from 'react';
import { Train, RefreshCw } from 'lucide-react';
// Track data
const INITIAL_TRACKS = [{
  id: 1,
  name: 'Arrival Line 1',
  status: 'FREE'
}, {
  id: 2,
  name: 'Arrival Line 2',
  status: 'OCCUPIED'
}, {
  id: 3,
  name: 'Loop Line 1',
  status: 'FREE'
}, {
  id: 4,
  name: 'Loop Line 2',
  status: 'OCCUPIED'
}, {
  id: 5,
  name: 'Unloading Line 1',
  status: 'OCCUPIED'
}, {
  id: 6,
  name: 'Unloading Line 2',
  status: 'FREE'
}, {
  id: 7,
  name: 'Departure Line 1',
  status: 'FREE'
}, {
  id: 8,
  name: 'Departure Line 2',
  status: 'OCCUPIED'
}];
// Monthly rake data
const MONTHLY_DATA = [{
  month: 'January',
  rake: 300,
  nonContainer: 400,
  container: 150
}, {
  month: 'February',
  rake: 500,
  nonContainer: 350,
  container: 200
}, {
  month: 'March',
  rake: 600,
  nonContainer: 400,
  container: 300
}, {
  month: 'April',
  rake: 1000,
  nonContainer: 500,
  container: 350
}, {
  month: 'May',
  rake: 400,
  nonContainer: 300,
  container: 200
}, {
  month: 'June',
  rake: 1200,
  nonContainer: 450,
  container: 600
}, {
  month: 'July',
  rake: 450,
  nonContainer: 350,
  container: 300
}];
// Vehicle entry/exit data
const VEHICLE_DATA = [{
  name: 'LP GAS 20FT',
  entry: 20,
  exit: 18
}, {
  name: 'LP GAS 40FT',
  entry: 15,
  exit: 12
}, {
  name: "40' CONTAINER",
  entry: 10,
  exit: 8
}, {
  name: 'BULLOCK CART',
  entry: 5,
  exit: 4
}, {
  name: 'JEEP',
  entry: 8,
  exit: 7
}];
// Top clients data
const CLIENT_DATA = [{
  name: 'Client A',
  sales: 72,
  warehouse: 65,
  rental: 58
}, {
  name: 'Client B',
  sales: 70,
  warehouse: 60,
  rental: 55
}, {
  name: 'Client C',
  sales: 68,
  warehouse: 62,
  rental: 50
}, {
  name: 'Client D',
  sales: 75,
  warehouse: 58,
  rental: 52
}, {
  name: 'Client E',
  sales: 80,
  warehouse: 70,
  rental: 60
}, {
  name: 'Client F',
  sales: 65,
  warehouse: 55,
  rental: 48
}, {
  name: 'Client G',
  sales: 78,
  warehouse: 68,
  rental: 56
}, {
  name: 'Client H',
  sales: 82,
  warehouse: 72,
  rental: 62
}];
// Track visual component - shows rail with/without train
function TrackVisual({
  status
}: {
  status: string;
}) {
  const isOccupied = status === 'OCCUPIED';
  return <svg viewBox="0 0 120 60" className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-1015">
      {/* Rails */}
      <rect x="0" y="38" width="120" height="3" rx="1" fill={isOccupied ? '#DC2626' : '#16A34A'} opacity="0.6" data-id="element-1016" />
      <rect x="0" y="48" width="120" height="3" rx="1" fill={isOccupied ? '#DC2626' : '#16A34A'} opacity="0.6" data-id="element-1017" />

      {/* Sleepers / ties */}
      {[10, 25, 40, 55, 70, 85, 100].map(x => <rect key={x} x={x} y="36" width="4" height="17" rx="1" fill={isOccupied ? '#DC2626' : '#16A34A'} opacity="0.3" data-id="element-1018" />)}

      {/* Train (only if occupied) */}
      {isOccupied && <g data-id="element-1019">
          {/* Locomotive body */}
          <rect x="15" y="10" width="55" height="26" rx="4" fill="#DC2626" data-id="element-1020" />
          <rect x="18" y="14" width="12" height="10" rx="2" fill="#FCA5A5" opacity="0.7" data-id="element-1021" />
          <rect x="34" y="14" width="12" height="10" rx="2" fill="#FCA5A5" opacity="0.7" data-id="element-1022" />

          {/* Chimney */}
          <rect x="22" y="4" width="8" height="8" rx="2" fill="#B91C1C" data-id="element-1023" />
          <ellipse cx="26" cy="3" rx="5" ry="2" fill="#9CA3AF" opacity="0.5" data-id="element-1024" />

          {/* Front */}
          <path d="M70 12 L80 18 L80 36 L70 36 Z" fill="#B91C1C" data-id="element-1025" />

          {/* Wagon */}
          <rect x="82" y="16" width="30" height="20" rx="3" fill="#EF4444" data-id="element-1026" />
          <rect x="85" y="19" width="10" height="8" rx="1.5" fill="#FCA5A5" opacity="0.5" data-id="element-1027" />
          <rect x="98" y="19" width="10" height="8" rx="1.5" fill="#FCA5A5" opacity="0.5" data-id="element-1028" />

          {/* Wheels */}
          <circle cx="28" cy="38" r="4" fill="#7F1D1D" data-id="element-1029" />
          <circle cx="28" cy="38" r="2" fill="#991B1B" data-id="element-1030" />
          <circle cx="55" cy="38" r="4" fill="#7F1D1D" data-id="element-1031" />
          <circle cx="55" cy="38" r="2" fill="#991B1B" data-id="element-1032" />
          <circle cx="90" cy="38" r="4" fill="#7F1D1D" data-id="element-1033" />
          <circle cx="90" cy="38" r="2" fill="#991B1B" data-id="element-1034" />
          <circle cx="105" cy="38" r="4" fill="#7F1D1D" data-id="element-1035" />
          <circle cx="105" cy="38" r="2" fill="#991B1B" data-id="element-1036" />

          {/* Coupling */}
          <rect x="78" y="28" width="6" height="3" rx="1" fill="#7F1D1D" data-id="element-1037" />
        </g>}

      {/* Empty track marker (only if free) */}
      {!isOccupied && <g data-id="element-1038">
          <circle cx="60" cy="24" r="10" fill="#DCFCE7" stroke="#16A34A" strokeWidth="2" data-id="element-1039" />
          <path d="M55 24 L58 27 L65 20" stroke="#16A34A" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-1040" />
        </g>}
    </svg>;
}
export function TrackStatusDashboard() {
  const [tracks] = useState(INITIAL_TRACKS);
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const handleRefresh = () => setLastUpdated(new Date());
  const maxRake = Math.max(...MONTHLY_DATA.map(d => d.rake));
  return <div className="flex flex-col gap-5 w-full h-full pb-10" data-id="element-1041">
      {/* Page Title */}
      <div className="flex items-center justify-between" data-id="element-1042">
        <h2 className="text-xl font-bold text-orange-500" data-id="element-1043">
          Daily Railways Reports
        </h2>
        <button onClick={handleRefresh} className="p-2 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors" data-id="element-1044">
          <RefreshCw size={18} className="text-gray-600" data-id="element-1045" />
        </button>
      </div>

      {/* Top Row: Track Status + Rake Chart */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5" data-id="element-1046">
        {/* Track Status */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5" data-id="element-1047">
          <h3 className="text-sm font-bold text-gray-900 text-center mb-3" data-id="element-1048">
            Track Status
          </h3>

          {/* Legend */}
          <div className="flex items-center justify-center gap-6 mb-4 text-xs" data-id="element-1049">
            <span className="flex items-center gap-1.5" data-id="element-1050">
              <span className="w-3 h-3 rounded-full bg-green-500 inline-block" data-id="element-1051" />{' '}
              Free
            </span>
            <span className="flex items-center gap-1.5" data-id="element-1052">
              <span className="w-3 h-3 rounded-full bg-red-500 inline-block" data-id="element-1053" />{' '}
              Occupied
            </span>
          </div>

          {/* Track Grid - Visual Rails */}
          <div className="grid grid-cols-2 gap-3" data-id="element-1054">
            {tracks.map(track => <div key={track.id} className={`rounded-lg p-3 border-2 ${track.status === 'OCCUPIED' ? 'border-red-200 bg-red-50' : 'border-green-200 bg-green-50'}`} data-id="element-1055">
                <div className="flex items-center justify-between mb-1" data-id="element-1056">
                  <p className="text-[11px] font-bold text-gray-800" data-id="element-1057">
                    {track.name}
                  </p>
                  <div className={`w-2 h-2 rounded-full ${track.status === 'OCCUPIED' ? 'bg-red-500 animate-pulse' : 'bg-green-500'}`} data-id="element-1058" />
                </div>
                <TrackVisual status={track.status} data-id="element-1059" />
              </div>)}
          </div>

          {/* Summary */}
          <div className="mt-4 pt-3 border-t border-gray-100 flex justify-center gap-6 text-xs text-gray-600" data-id="element-1060">
            <span data-id="element-1061">
              Free:{' '}
              <strong className="text-green-600" data-id="element-1062">
                {tracks.filter(t => t.status === 'FREE').length}
              </strong>
            </span>
            <span data-id="element-1063">
              Occupied:{' '}
              <strong className="text-red-600" data-id="element-1064">
                {tracks.filter(t => t.status === 'OCCUPIED').length}
              </strong>
            </span>
            <span data-id="element-1065">
              Total: <strong data-id="element-1066">{tracks.length}</strong>
            </span>
          </div>
        </div>

        {/* No of Rake - Bar Chart */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5" data-id="element-1067">
          <div className="flex items-center justify-center gap-6 mb-4 text-xs" data-id="element-1068">
            <span className="flex items-center gap-1.5" data-id="element-1069">
              <span className="w-3 h-3 rounded bg-red-400 inline-block" data-id="element-1070" /> No of
              Rake
            </span>
            <span className="flex items-center gap-1.5" data-id="element-1071">
              <span className="w-3 h-3 rounded bg-teal-500 inline-block" data-id="element-1072" />{' '}
              Non-Containerised
            </span>
            <span className="flex items-center gap-1.5" data-id="element-1073">
              <span className="w-3 h-3 rounded bg-blue-500 inline-block" data-id="element-1074" />{' '}
              Containerised
            </span>
          </div>
          <div className="flex items-end gap-1 h-52 px-2" data-id="element-1075">
            {MONTHLY_DATA.map((d, i) => <div key={i} className="flex-1 flex flex-col items-center gap-1" data-id="element-1076">
                <div className="w-full flex items-end justify-center gap-0.5 h-44" data-id="element-1077">
                  <div className="w-3 bg-teal-500 rounded-t" style={{
                height: `${d.nonContainer / maxRake * 100}%`
              }} data-id="element-1078" />
                  <div className="w-3 bg-blue-500 rounded-t" style={{
                height: `${d.container / maxRake * 100}%`
              }} data-id="element-1079" />
                </div>
                <span className="text-[9px] text-gray-500 font-medium" data-id="element-1080">
                  {d.month.slice(0, 3)}
                </span>
              </div>)}
          </div>
          <div className="flex justify-between px-2 mt-1" data-id="element-1081">
            <span className="text-[9px] text-gray-400" data-id="element-1082">0</span>
            <span className="text-[9px] text-gray-400" data-id="element-1083">600</span>
            <span className="text-[9px] text-gray-400" data-id="element-1084">1,200</span>
          </div>
        </div>
      </div>

      {/* Bottom Row: Vehicle Entry/Exit + Top Clients */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5" data-id="element-1085">
        {/* Vehicle Entry / Exit */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5" data-id="element-1086">
          <div className="flex items-center justify-center gap-6 mb-4 text-xs" data-id="element-1087">
            <span className="flex items-center gap-1.5" data-id="element-1088">
              <span className="w-3 h-3 rounded bg-red-400 inline-block" data-id="element-1089" />{' '}
              Vehicle Entry
            </span>
            <span className="flex items-center gap-1.5" data-id="element-1090">
              <span className="w-3 h-3 rounded bg-blue-500 inline-block" data-id="element-1091" />{' '}
              Vehicle Exit
            </span>
          </div>
          <div className="space-y-3" data-id="element-1092">
            {VEHICLE_DATA.map((v, i) => <div key={i} className="space-y-1" data-id="element-1093">
                <div className="flex items-center justify-between" data-id="element-1094">
                  <span className="text-xs font-medium text-gray-700 w-28 truncate" data-id="element-1095">
                    {v.name}
                  </span>
                  <span className="text-[10px] text-gray-500" data-id="element-1096">
                    {v.entry} / {v.exit}
                  </span>
                </div>
                <div className="flex gap-1 h-4" data-id="element-1097">
                  <div className="bg-red-400 rounded-sm" style={{
                width: `${v.entry / 25 * 100}%`
              }} data-id="element-1098" />
                  <div className="bg-blue-500 rounded-sm" style={{
                width: `${v.exit / 25 * 100}%`
              }} data-id="element-1099" />
                </div>
              </div>)}
          </div>
        </div>

        {/* Top 5 Clients Vehicle Entries */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5" data-id="element-1100">
          <h3 className="text-sm font-bold text-gray-900 text-center mb-3" data-id="element-1101">
            Top 5 Clients Vehicle Entries
          </h3>
          <div className="flex items-center justify-center gap-6 mb-4 text-xs" data-id="element-1102">
            <span className="flex items-center gap-1.5" data-id="element-1103">
              <span className="w-3 h-3 rounded bg-red-400 inline-block" data-id="element-1104" /> Sales
            </span>
            <span className="flex items-center gap-1.5" data-id="element-1105">
              <span className="w-3 h-3 rounded bg-blue-400 inline-block" data-id="element-1106" />{' '}
              Warehouse
            </span>
            <span className="flex items-center gap-1.5" data-id="element-1107">
              <span className="w-3 h-3 rounded bg-orange-400 inline-block" data-id="element-1108" />{' '}
              Rental
            </span>
          </div>
          <div className="flex items-end gap-1 h-44 px-1" data-id="element-1109">
            {CLIENT_DATA.map((c, i) => <div key={i} className="flex-1 flex flex-col items-center gap-1" data-id="element-1110">
                <div className="w-full flex items-end justify-center gap-px h-36" data-id="element-1111">
                  <div className="w-2.5 bg-red-400 rounded-t" style={{
                height: `${c.sales / 90 * 100}%`
              }} data-id="element-1112" />
                  <div className="w-2.5 bg-blue-400 rounded-t" style={{
                height: `${c.warehouse / 90 * 100}%`
              }} data-id="element-1113" />
                  <div className="w-2.5 bg-orange-400 rounded-t" style={{
                height: `${c.rental / 90 * 100}%`
              }} data-id="element-1114" />
                </div>
                <span className="text-[9px] text-gray-500 font-medium" data-id="element-1115">
                  {c.name.replace('Client ', '')}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}